import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    style: !_vm.applicationCanBeEdited ? 'opacity: 0.9' : '',
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "max-width": "900"
    },
    model: {
      value: _vm.formDialog,
      callback: function ($$v) {
        _vm.formDialog = $$v;
      },
      expression: "formDialog"
    }
  }, [_vm.formDialog ? _c('niota-classic-applications-form', {
    attrs: {
      "editedItem": _vm.applicationObject
    },
    on: {
      "close": _vm.closeForm,
      "update": _vm.updateItem
    }
  }) : _vm._e()], 1), _c(VForm, {
    ref: "form",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('core-header', {
    attrs: {
      "subtitle": _vm.$i18n_tc('NiotaClassic.Applications.details.devicesLinked', (_vm.applicationObject || {}).deviceCount || 0, {
        n: (_vm.applicationObject || {}).deviceCount || 0
      }),
      "headerBG": (_vm.applicationObject || {}).image && _vm.getImageUrl((_vm.applicationObject || {}).image),
      "isLoading": !_vm.applicationObject.id
    },
    scopedSlots: _vm._u([{
      key: "headline",
      fn: function () {
        return [_c(VIcon, {
          class: _vm.color + '--text headline-icon mr-1',
          attrs: {
            "medium": ""
          }
        }, [_vm._v("fal fa-laptop")]), _vm._v("\n        " + _vm._s((_vm.applicationObject || {}).title || 'Application') + " (ID " + _vm._s(_vm.applicationObject.id) + ")\n      ")];
      },
      proxy: true
    }, {
      key: "buttons",
      fn: function () {
        return [_vm.isIotHubManager ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-edit"
          },
          on: {
            "click": function ($event) {
              return _vm.editItem();
            }
          }
        }, [_vm._v("\n          " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.editButton')) + "\n        ")]) : _c('core-button', {
          attrs: {
            "color": _vm.color,
            "prepend-icon": "fa-eye"
          },
          on: {
            "click": function ($event) {
              return _vm.editItem();
            }
          }
        }), _c('core-button', {
          attrs: {
            "color": "danger",
            "title": _vm.$i18n_t('Common.cancel'),
            "prepend-icon": "fa-times"
          },
          on: {
            "click": function ($event) {
              return _vm.viewAllApplications();
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow pb-12",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c(VTabs, {
    class: {
      sm: _vm.$vuetify.breakpoint.smAndDown
    },
    attrs: {
      "show-arrows": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabsSlider, {
    attrs: {
      "color": _vm.color
    }
  }), _c(VTab, {
    attrs: {
      "href": "#tab-details"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-list")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.tabs.details')) + "\n            ")], 1), _c(VTab, {
    attrs: {
      "href": "#tab-devices"
    }
  }, [_c(VIcon, {
    staticClass: "mr-3"
  }, [_vm._v("fal fa-sensor-on")]), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Applications.table.devices')) + "\n            ")], 1), _c(VTabsItems, {
    attrs: {
      "touchless": ""
    },
    model: {
      value: _vm.tabItem,
      callback: function ($$v) {
        _vm.tabItem = $$v;
      },
      expression: "tabItem"
    }
  }, [_c(VTabItem, {
    key: "details",
    attrs: {
      "value": "tab-details"
    }
  }, [_c('niota-classic-applications-details', {
    ref: "applicationDetails",
    attrs: {
      "applicationObj": _vm.applicationObject
    }
  })], 1), _c(VTabItem, {
    key: "devices",
    attrs: {
      "value": "tab-devices"
    }
  }, [_c('niota-classic-applications-linked-devices-list', {
    ref: "devicesList"
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };